import { MedicalImageInterface } from '@/shared/config';

import {
  TOOTH_BASIS_SERIES_TO_GROUP,
  type FullHeadMprSliceGroupView,
  type FullHeadMprSliceTileView,
} from '../config';

export const makeTileMedicalImage = ({
  group,
  tile,
}: {
  group?: FullHeadMprSliceGroupView;
  tile: FullHeadMprSliceTileView;
}): MedicalImageInterface => ({
  id: tile.id,
  src: tile.pngUrl,
  assetID: tile.id,
  groupName: TOOTH_BASIS_SERIES_TO_GROUP[tile.seriesName],
  kind: 'raster',
  order: tile.order,
  strideMm: tile.kind === 'view' ? 0 : group?.sliceStepMm ?? 0,
  thicknessMm:
    tile.kind === 'view' ? tile.view.thicknessMm : group?.slabThicknessMm ?? 0,
});
